{
  "Fintraffic-traffic": "Traffic Situation",
  "Fintraffic-feedback": "Feedback Channel",
  "Fintraffic-train": "Train Departures",
  "Fintraffic-digitraffic": "Digitraffic",
  "Fintraffic-digitransit": "Digitransit",
  "Fintraffic-nap": "NAP",
  "Fintraffic-contact": "Contact Information",
  "Fintraffic-contactLink": "contact-information-and-invoicing-instructions",
  "Fintraffic-privacy": "Privacy Policy",
  "Fintraffic-accessibility": "Accessibility",
  "Fintraffic-about": "About",
  "Fintraffic-instructions": "Instructions",
  "Fintraffic-terms": "Terms and conditions",
  "Fintraffic-support": "Support",
  "Fintraffic-channels": "Support channels",
  "Fintraffic-fintrafficApp": "Fintraffic App",
  "Fintraffic-fintrafficAppLink": "digitalservices/fintraffic_app",
  "Entur-cooperation": "Entur cooperation",
  "_title": "Stop and accessibility database"
}
